import { apiRoutes } from '@/../config'
import Vue from 'vue'
import axios from 'axios'

const state = { status: '', credentials: {} }

const getters = {
    user: state => state.credentials.user,
    isCredentialsLoaded: state => !!state.credentials && !!state.credentials.user && state.credentials.user.email.length > 0,
    firstname: state => state.credentials && state.credentials.user ? state.credentials.user.firstname : '',
    lastname: state => state.credentials && state.credentials.user ? state.credentials.user.lastname : '',
    email: state => state.credentials && state.credentials.user ? state.credentials.user.email : '',
    userID: state => state.credentials && state.credentials.user ? state.credentials.user._id : ''
}

const actions = {
    user_request: async ({ commit, dispatch }) => {
        commit('user_request')
        try {
            const res = axios.post(apiRoutes.refreshToken)
            axios.defaults.headers.common.Authorization = 'Bearer' + res.data.model.accessToken
        } catch (e) {
            dispatch('auth_logout')
            commit('user_logout')
            commit('user_error')
        }
    }
}

const mutations = {
    user_request: async state => {
        state.status = 'loading'
    },
    user_success: (state, credentials) => {
        state.status = 'success'
        Vue.set(state, 'credentials', credentials)
    },
    user_error: state => {
        state.status = 'error'
    },
    user_logout: state => {
        state.credentials = {}
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
